import { AccountAnalysisState } from '@core/model/domain/accountAnalysisState';
import { Result } from '@core/model/framework/Result/Result';
import { WaitOnBankAccountAnalysisCompletion } from '@core/usecase/waitOnBankAccountAnalysisCompletion';
import { StoreService } from '@shared/services/store.service';

export class AccountsAnalysisVM {
  constructor(
    private readonly storeService: StoreService,
    private waitOnBankAccountAnalysisCompletion: WaitOnBankAccountAnalysisCompletion
  ) {}

  async waitOnRequestAnalysis(selectedAccountsId: string[]): Promise<AccountAnalysisState> {
    const userId = this.storeService.getVariableOrThrow('USER_ID');
    const userToken = this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN');
    const connectionId = this.storeService.getVariableOrThrow('SELECTED_CONNECTION_ID');

    const bankAccountAnalysisResult = await this.waitOnBankAccountAnalysisCompletion.execute({
      userId,
      userToken,
      connectionId,
      selectedAccountsId,
    });

    const accountAnalysisState = Result.unwrap(bankAccountAnalysisResult);
    this.storeService.setVariable('ACCOUNT_ANALYSIS_STATE', accountAnalysisState);

    return accountAnalysisState;
  }
}
